import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import {
  ContainerCustomArea,
  ContarCaracteres,
  CustomTextarea,
  FormContainer,
  InstrucoesContainer,
  TituloDropdown,
  TituloInput,
} from "./style";
import { DropdownSelect } from "components/DropdownSelect";
import { useEffect, useState } from "react";
import { useProcessoFinanceiroDescricao } from "hooks/useProcessoFinanceiroDescricao";
import { CustomInput } from "components/CustomInput";
import { IEditarProcesso } from "../../../../../interface/IEditarProcesso";
import { useMaskInput } from "hooks/useMaskInput";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: () => void;
  idFornecedor: number | undefined;
  dadosEditarProcesso: IEditarProcesso | null;
  setDadosEditarProcesso: (dados: IEditarProcesso | null) => void;
}

export function ModalEditarProcesso({
  show,
  handleClose,
  onSubmit,
  idFornecedor,
  dadosEditarProcesso,
  setDadosEditarProcesso,
}: Props) {
  const {
    processosFinanceirosDescricoesOptions,
    todosProcessosFinanceirosDescricoesOptions,
    listarOptions,
  } = useProcessoFinanceiroDescricao();
  const { mInputCoin } = useMaskInput();

  useEffect(() => {
    listarOptions(idFornecedor);
  }, [show]);

  const onChangeCustoProcesso = (valor: number) => {
    if (!dadosEditarProcesso) {
      return;
    }

    setDadosEditarProcesso({
      ...dadosEditarProcesso,
      valorDepois: valor,
    });
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar processo"
      centered
    >
      <FormContainer>
        <TituloDropdown>Serviço</TituloDropdown>
        <DropdownSelect
          options={
            processosFinanceirosDescricoesOptions.length
              ? processosFinanceirosDescricoesOptions
              : todosProcessosFinanceirosDescricoesOptions
          }
          selectedValue={dadosEditarProcesso?.servicoDepois}
          onSelect={(value) => {
            if (!dadosEditarProcesso) {
              return;
            }

            setDadosEditarProcesso({
              ...dadosEditarProcesso,
              servicoDepois: value,
              nomeServicoDepois:
                todosProcessosFinanceirosDescricoesOptions.find(
                  (option) => option.value == value
                )?.label ?? "",
            });
          }}
          searchable
        />
        <TituloInput>Custo do processo</TituloInput>
        <CustomInput
          type="text"
          placeholder="Digite o custo do processo"
          value={dadosEditarProcesso?.valorDepois}
          onKeyDown={(e) => {
            if (
              !/[0-9]/.test(e.key) &&
              e.key !== "Backspace" &&
              e.key !== "Delete" &&
              e.key !== "ArrowLeft" &&
              e.key !== "ArrowRight" &&
              e.key !== "Tab"
            ) {
              e.preventDefault();
            }
          }}
          onChange={(e) => onChangeCustoProcesso(mInputCoin(e))}
        />
      </FormContainer>
      <div className="d-flex justify-content-end gap-4">
        <PrimaryButton
          style={{ width: "6rem" }}
          outline
          variante="primary"
          onClick={handleClose}
        >
          Cancelar
        </PrimaryButton>
        <PrimaryButton
          style={{ width: "6rem" }}
          onClick={onSubmit}
          disabled={
            !dadosEditarProcesso ||
            (dadosEditarProcesso.servicoDepois ==
              dadosEditarProcesso.servicoAntes &&
              dadosEditarProcesso.valorDepois == dadosEditarProcesso.valorAntes)
          }
        >
          Alterar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
